export default __webpack_public_path__ + "static/media/Q3_0.a46421fe.jpg";